import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import chapterApiProvider from '../../apiProvider/chapterApi';
import { useParams } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../network/apiClient';
import { toast, ToastContainer } from 'react-toastify';

const ThankyouNoteLayer = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [chapterMembers, setchapterMembers] = useState([])
    const [gripChaptersData, setGripChaptersData] = useState([])
    const handleShowImage = (imageUrl) => {
        setSelectedImage(imageUrl);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedImage('');
    };
    const { id } = useParams();
    const data = [
        {
            id: 1,
            date: "2025-05-10",
            from: "Elankathir",
            thankTo: "Prathap",
            value: "₹50000",
            comment: "Great support on the event",
            chapter: "GRIP Aram",
            image: "assets/images/user-grid/user-grid-bg1.png",
        },
        {
            id: 2,
            date: "2025-05-11",
            from: "Vignesh",
            thankTo: "Surya",
            value: "₹7500000",
            comment: "Excellent referral given",
            chapter: "GRIP Virutcham",
            image: "assets/images/user-grid/user-grid-bg1.png",
        },
        {
            id: 3,
            date: "2025-05-12",
            from: "Naresh",
            thankTo: "Ramesh",
            value: "₹6000000",
            comment: "Helped with business lead",
            chapter: "GRIP Aram",
            image: "assets/images/user-grid/user-grid-bg1.png",
        },
        {
            id: 4,
            date: "2025-05-13",
            from: "Deepak",
            thankTo: "Abraham",
            value: "₹100000",
            comment: "Valuable market insight",
            chapter: "GRIP Virutcham",
            image: "assets/images/user-grid/user-grid-bg1.png",
        },
        {
            id: 5,
            date: "2025-05-14",
            from: "Prakash",
            thankTo: "Adhi",
            value: "₹450000",
            comment: "On-time delivery support",
            chapter: "GRIP Virutcham",
            image: "assets/images/user-grid/user-grid-bg1.png",
        },
    ];
    const fetchChapters = async (id) => {
        try {
            const response = await chapterApiProvider.thankYouSlipListMember(id);
            console.log(response, "responce-chapterApiProvider");
            setchapterMembers(response?.response?.data)
            // You can set the response to state here if needed
        } catch (error) {
            console.error("Error fetching chapters:", error);
            // Handle the error (e.g., show error message to user)
        }
    };
    useEffect(() => {
        fetchChapters(id);
    }, [id]);
    console.log(chapterMembers, "chapterMembers")
    const handleStatusChange = async (status, recordId) => {
        console.log(status, "status", recordId, "recordId")
        if (!status) return;
        try {
            let input = {
                status: status,
                id: recordId,
                formName: "thankyouslips"
            }
            const response = await chapterApiProvider.changeStatus(input);
            console.log(response, "responce-chapterApiProvider");
            // Handle success
            if (response) {
                toast("status updated successfully")
                fetchChapters(id);
            }
            else {
                toast("failed to update status")
                fetchChapters(id);
            }

        } catch (error) {
            console.error('Error updating status:', error);
            alert('Failed to update status');
        } finally {
        }
    };
    return (
        <div className="col-xxl-12 col-xl-12">
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        {/* <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                name="search"
                                placeholder="Search"
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form> */}
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-3">

                        {/* <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                            <option value="Select Number" disabled>
                                Select Chapter
                            </option>
                            <option value="10">GRIP Aram</option>
                            <option value="15">GRIP Virutcham</option>
                            <option value="20">GRIP Madhuram</option>
                            <option value="20">GRIP Kireedam</option>
                            <option value="20">GRIP Amudham</option>
                        </select> */}
                        <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                            <option value="Select Number" >
                                This Week
                            </option>
                            <option value="10">This Month</option>
                            <option value="15">Last Week</option>
                            <option value="20">Last Month</option>
                            <option value="20">This Term</option>


                        </select>

                    </div>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>From</th>
                                    <th>Thank to</th>
                                    <th>Value</th>
                                    <th>Commends</th>
                                    <th>Chapter</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chapterMembers?.records?.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}.</td>
                                        <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                                        <td>
                                            {item.fromMember.name} ({item.fromMember.mobile})
                                            {item.fromMember.profileImage && (
                                                <img
                                                    src={item.fromMember.profileImage}
                                                    alt="Profile"
                                                    className="profile-image"
                                                    style={{ width: '30px', height: '30px', borderRadius: '50%', marginLeft: '8px' }}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            {item.toMember.name} ({item.toMember.mobile})
                                            {item.toMember.profileImage && (
                                                <img
                                                    src={
                                                        item.toMember.profileImage
                                                            ? `${IMAGE_BASE_URL}/${item.toMember.profileImage.docPath}/${item.toMember.profileImage.docName}`
                                                            : "/assets/imgs/theme/icons/category-1.svg"
                                                    }
                                                    alt={item.toMember.name || "Profile"}
                                                    className="profile-image"
                                                    style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        borderRadius: '50%',
                                                        marginLeft: '8px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>{item.amount}</td>
                                        <td>{item.comments}</td>
                                        <td>
                                            {chapterMembers && (
                                                <>
                                                    <div>{chapterMembers?.chapter?.chapterName}</div>
                                                    <small className="text-muted">Zone: {chapterMembers?.chapter?.zoneName}</small>
                                                </>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <select
                                                className="form-select form-select-sm w-auto"
                                                onChange={(e) => handleStatusChange(e.target.value, item._id)}
                                                value={item.status || ""} // Set default to empty or current status
                                            >
                                                <option value="" disabled>Select Action</option>
                                                <option value="active">Active</option>
                                                <option value="decline">decline</option>
                                            </select>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Image Modal */}
                    <Modal show={showModal} onHide={handleClose} centered>
                        <Modal.Body className="text-center">
                            <img src={selectedImage} alt="Popup" className="img-fluid" />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
            <ToastContainer/>
        </div>
    );
};

export default ThankyouNoteLayer;
